import { render, staticRenderFns } from "./FTabs.vue?vue&type=template&id=5f7effd4&scoped=true"
import script from "./FTabs.vue?vue&type=script&lang=ts"
export * from "./FTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7effd4",
  null
  
)

export default component.exports